import { Controller } from "@hotwired/stimulus"
import { currentLocation } from "../helpers/location.js"
import { sendFilter } from "../helpers/filter.js"

export default class extends Controller {
  static targets = ['id']

  connect() {}

  copy_id(event) {
    event.preventDefault()
    this.copyToClipboard(event.currentTarget.children[0].innerHTML)
    $(document).Toasts('create', {
      autohide: true,
      position: 'bottomLeft',
      delay: 3000,
      title: event.currentTarget.dataset.title,
      body: event.currentTarget.dataset.message,
      class: 'bg-success'
    })
  }

  copyToClipboard(str) {
    const el = document.createElement('textarea')
    el.value = str
    el.setAttribute('readonly', '')
    el.style.position = 'absolute'
    el.style.left = '-9999px'
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
  }

}
